import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const Model = withFacetContext(
    FacetName.model,
    withFilterContext(FilterName.model, SearchFiltersDropdown, {
        title: 'Model',
        renderFilterBar: true,
    })
)
